<template>
  <div id="app">
    <fade-transition origin="center" mode="out-in" :duration="250">
      <router-view/>
    </fade-transition>
  </div>
</template>

<script>
import firebase from "firebase/app"
import "firebase/auth"
export default {
  name: 'App',
  async mounted() {
    if (!firebase.auth().currentUser) {
      await this.$store.dispatch('checkToken')
    }
  }
}
</script>

<style>
* {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
  transition: 0.1s;
}

</style>
